import PLDocumentUpload from '../PLDocumentUpload'
import BankAggregatorSelector from '../common/bankAggregatorSelector'
import DateSelector from '../common/dateSelector'
import MobileNumberInput from '../common/mobileNumber'
import PincodeSelector from '../common/pincodeSelector'
import { RadioButton } from '../common/radioButton'
import { RadioButtonStepper } from '../common/radioButtonStepper'
import SelectDropDown from '../common/selectDropDown'
import TextInput from '../common/textInput'
import { Toggle } from '../common/toggle'
import DocumentUploadScreen from '../documentUploadScreen'

export const formComponentMap = {
  text: {
    component: TextInput,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      config: 'config',
    },
    propValues: {
      type: 'text',
      noIconPadding: true,
    },
  },
  number: {
    component: TextInput,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      config: 'config',
    },
    propValues: {
      type: 'number',
      keyboardType: 'number-pad',
    },
  },
  toggle: {
    component: Toggle,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      fieldOptions: 'fieldOptions',
    },
  },
  radio: {
    component: RadioButton,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      fieldOptions: 'fieldOptions',
      ocFieldCode: 'ocFieldCode',
    },
  },
  radioStepper: {
    component: RadioButtonStepper,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      fieldOptions: 'fieldOptions',
      ocFieldCode: 'code',
    },
  },
  select: {
    component: SelectDropDown,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      options: 'fieldOptions',
    },
  },
  search: {
    component: SelectDropDown,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      options: 'fieldOptions',
      fieldId: 'id',
      ocFieldCode: 'code',
    },
    propValues: {
      isSearchable: true,
    },
  },
  date: {
    component: DateSelector,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      label: 'name',
      config: 'config',
    },
  },
  pincode: {
    component: PincodeSelector,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      options: 'fieldOptions',
      fieldId: 'id',
      ocFieldCode: 'ocFieldCode',
    },
    propValues: {
      isSearchable: true,
      data: {
        state: '',
        city: '',
      },
    },
  },
  selectDocument: {
    component: DocumentUploadScreen,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      options: 'fieldOptions',
      fieldId: 'id',
    },
    propValues: {
      selectDocument: true,
    },
  },
  upload: {
    component: DocumentUploadScreen,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      options: 'fieldOptions',
      fieldId: 'id',
      config: 'config',
    },
  },
  file: {
    component: PLDocumentUpload,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      options: 'fieldOptions',
      fieldId: 'id',
      config: 'config',
      code: 'code',
    },
  },
  phoneNumber: {
    component: MobileNumberInput,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      config: 'config',
    },
    propValues: {
      type: 'text',
      noIconPadding: true,
      countryCode: '+91',
    },
  },
  bankAggregatorSelect: {
    component: BankAggregatorSelector,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'name',
      options: 'fieldOptions',
      fieldId: 'id',
      ocFieldCode: 'code',
    },
    propValues: {
      isSearchable: true,
      data: {
        isAaRecommended: 'Y',
        isAccountAggregator: 'Y',
        isAnumati: 'Y',
        isNetBanking: 'Y',
        isNetBankingRecommended: 'N',
      },
      radioStepperProps: {
        label: 'Select Mode of Income Varification',
        component: RadioButtonStepper,
        onChange: 'onChange',
        onBlur: 'onBlur',
        fieldOptions: [
          {
            optionId: 'ACCOUNT_AGGREGATOR',
            optionValue: 'Account Aggregator',
            orderNo: 1,
            recommended: true,
            recommendationKey: 'isAaRecommended',
            showField: 'isAccountAggregator',
            description: 'Share details using an RBI licensed process',
          },
          {
            optionId: 'NET_BANKING',
            optionValue: 'Netbanking',
            orderNo: 2,
            recommendationKey: 'isNetBankingRecommended',
            showField: 'isNetBanking',
          },
        ],
        isRequired: true,
      },
    },
  },
}
